import { useRef } from 'react'
import Styles from './CustomizeDrawer.module.scss'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'
import { Button } from 'blaze-ui/Button'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { CustomizeDrawer } from './CustomizeDrawer'
import { CustomizeProps } from './Types'

export const CustomizeButton = observer((props: CustomizeProps) => {
  const { openDrawer } = useRootStore().drawersStore
  const ref = useRef<HTMLDivElement>(null)

  const openCustomizeDrawer = () => {
    openDrawer(CustomizeDrawer, { ...props })
  }

  const { buttonProps } = useButtonWithScrollCancel({ onPress: openCustomizeDrawer, elementType: 'div' }, ref)

  return (
    <div {...buttonProps} className={Styles.customizeButtonContainer} ref={ref}>
      <div className={Styles.customizeText}>
        <span className={Styles.title}>More ways to configure</span>
      </div>
      <Button variant="tertiary" size="md" frontIcon={ChevronRightSmall} rounded onPress={openCustomizeDrawer} />
    </div>
  )
})
